import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse, HttpErrorResponse }
  from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LoaderService } from '../Loader/loader.service';

@Injectable()
export class MyInterceptor implements HttpInterceptor {
  constructor(private router: Router,private service: NbAuthService, private loaderService: LoaderService){}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.showLoader();
    return next.handle(req).pipe(tap((event: HttpEvent<any>) => { 
      if (event instanceof HttpResponse) {
        setTimeout(() => {
          this.onEnd();
        }, 1000);
      }
    })).pipe(
      catchError( (error: HttpErrorResponse) => { 
          if(error.error.code == 401){
            this.onEnd();
            localStorage.removeItem('auth_app_token');
            this.router.navigate(['auth/login']);
          }
          else{
            this.onEnd();
          }
          return throwError(error);
       })
    );;

  }
  private onEnd(): void {
    this.hideLoader();
}
private showLoader(): void {
    this.loaderService.show();
}
private hideLoader(): void {
    this.loaderService.hide();
}
}